var map = {
	"./AboutUs.jsx": [
		1666,
		1591,
		1666
	],
	"./Admin/Clinic/ClinicAdd.jsx": [
		865,
		6182,
		2895,
		8047,
		865
	],
	"./Admin/Clinic/ClinicList.jsx": [
		4966,
		4966
	],
	"./Admin/Dashboard.jsx": [
		3509,
		1591,
		3509
	],
	"./Admin/Disease/DiseaseAdd.jsx": [
		5451,
		6182,
		2895,
		8047,
		5451
	],
	"./Admin/Disease/DiseaseList.jsx": [
		3616,
		3616
	],
	"./Admin/Doctors/DoctorsAdd.jsx": [
		2799,
		6182,
		2895,
		8047,
		2799
	],
	"./Admin/Doctors/DoctorsList.jsx": [
		3612,
		3612
	],
	"./Admin/Enquiry/ClinicEnquiry.jsx": [
		7248,
		7248
	],
	"./Admin/Enquiry/DoctorEnquiry.jsx": [
		9647,
		9647
	],
	"./Admin/HealingStories/HealingStoriesAdd.jsx": [
		8203,
		6182,
		2895,
		8047,
		8203
	],
	"./Admin/HealingStories/HealingStoriesList.jsx": [
		6704,
		6704
	],
	"./Admin/HerbsFood/HerbsFoodAdd.jsx": [
		4652,
		6182,
		2895,
		8047,
		2271
	],
	"./Admin/HerbsFood/HerbsFoodList.jsx": [
		2140,
		2140
	],
	"./Admin/Login.jsx": [
		6350,
		1591,
		6182,
		2895,
		8047,
		6350
	],
	"./Admin/MedicineBlog/MedicineBlogAdd.jsx": [
		7229,
		6182,
		2895,
		8047,
		7229
	],
	"./Admin/MedicineBlog/MedicineBlogList.jsx": [
		2970,
		2970
	],
	"./Admin/VideoBlog/BlogVideosAdd.jsx": [
		1588,
		6182,
		2895,
		8047,
		1588
	],
	"./Admin/VideoBlog/BlogVideosList.jsx": [
		529,
		529
	],
	"./Blog/HerbsFood/HerbsFood.jsx": [
		353,
		1591,
		353
	],
	"./Blog/HerbsFood/HerbsFoodDetail.jsx": [
		9074,
		9074
	],
	"./Blog/MedicineBlog/MedicineBlog.jsx": [
		5327,
		1591,
		5327
	],
	"./Blog/MedicineBlog/MedicineBlogDetail.jsx": [
		6206,
		1591,
		6206
	],
	"./Blog/VideoBlog/VideoBlog.jsx": [
		4069,
		1591,
		4069
	],
	"./Blog/VideoBlog/VideoBlogDetail.jsx": [
		6758,
		6758
	],
	"./ClinicDetails.jsx": [
		5955,
		1591,
		6182,
		2895,
		6717,
		8047,
		5955
	],
	"./Consult.jsx": [
		329,
		1591,
		6182,
		2895,
		1378,
		8047,
		9157
	],
	"./ConsultDetail.jsx": [
		1546,
		1591,
		1546
	],
	"./ContentIntegrity.jsx": [
		4373,
		1591,
		4373
	],
	"./DiseaseDetail.jsx": [
		6240,
		1591,
		6240
	],
	"./Diseases.jsx": [
		8552,
		1591,
		8552
	],
	"./DoctorDetail.jsx": [
		7707,
		1591,
		6182,
		2895,
		6717,
		8047,
		7707
	],
	"./EditorialPolicy.jsx": [
		3880,
		1591,
		3880
	],
	"./HealingStories.jsx": [
		1815,
		1591,
		4196
	],
	"./HomePage.jsx": [
		2204,
		1591,
		6182,
		1378,
		3456
	],
	"./KidneyFailure.jsx": [
		2707,
		1591,
		6182,
		1378,
		9103
	],
	"./NotFound.jsx": [
		1804,
		1804
	],
	"./OurCenters.jsx": [
		9497,
		1591,
		9497
	],
	"./OurExperts.jsx": [
		3356,
		1591,
		3356
	],
	"./PainManagement.jsx": [
		1852,
		1591,
		6182,
		1378,
		8512
	],
	"./PrivacyPolicy.jsx": [
		1027,
		1591,
		1027
	],
	"./ReturnPolicy.jsx": [
		8513,
		1591,
		8513
	],
	"./ShippingPolicy.jsx": [
		541,
		1591,
		541
	],
	"./TermsCondition.jsx": [
		4061,
		1591,
		4061
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7510;
module.exports = webpackAsyncContext;